import { StatusEnum } from '../../Enum/StatusEnum';

export default interface IMemberAssessmentStatuses {
    DocumentEngagementId: string;

    AbuseHistoryStatus: StatusEnum;
    AdditionalCHPCriteriaStatus: StatusEnum;
    AdlAssessmentStatus: StatusEnum;
    AdvancedDirectiveStatus: StatusEnum;
    AllergyStatus: StatusEnum;
    BHDiagnosticStatus: StatusEnum;
    BudgetFormStatus: StatusEnum;
    CarePlanStatus: StatusEnum;
    CounselingStatus: StatusEnum;
    CulturalConsiderationsStatus: StatusEnum;
    CurrentNeedsStatus: StatusEnum;
    DiabetesFootStatus: StatusEnum;
    DemographicStatus: StatusEnum;
    DevelopmentalHistoryStatus: StatusEnum;
    DocumentEngagementStatus: StatusEnum;
    EatingDisorderStatus: StatusEnum;
    EducationStatus: StatusEnum;
    FactorAndRiskAssessmentStatus: StatusEnum;
    FallRiskStatus: StatusEnum;
    FollowUpStatus: StatusEnum;
    GAFScaleStatus: StatusEnum;
    GoalStatus: StatusEnum;
    HamiltonAnxietyScaleStatus: StatusEnum;
    HealthPlanStatus: StatusEnum;
    HgbA1CStatus: StatusEnum;
    HraEducationStatus: StatusEnum;
    InterventionStatus: StatusEnum;
    IsConsentToService: boolean;
    LegalHistoryStatus: StatusEnum;
    LipidStatus: StatusEnum;
    MedicationReconciliationStatus: StatusEnum;
    MentalHealthTreatmentHistoryStatus: StatusEnum;
    MiniMentalExamStatus: StatusEnum;
    PastPresentHistoryStatus: StatusEnum;
    PastSurgicalHistoryStatus: StatusEnum;
    PcpSpecialistStatus: StatusEnum;
    PhqStatus: StatusEnum;
    PhysicalExamStatus: StatusEnum;
    PreventativeHealthAdviceStatus: StatusEnum;
    ProgressNoteStatus: StatusEnum;
    RequestStatus: StatusEnum;
    RemoteMonitoringStatus: StatusEnum;
    ReviewSystemStatus: StatusEnum;
    ScreeningFuhfumStatus: StatusEnum;
    SdohAssessmentStatus: StatusEnum;
    SexualHealthStatus: StatusEnum;
    SubjectiveAssessmentStatus: StatusEnum;
    SuicidalHomicidalIdeationStatus: StatusEnum;
    TabletStatus: StatusEnum;
    TobaccoAndDrugAssessmentStatus: StatusEnum;
    UrinalysisReportStatus: StatusEnum;
    VisionAndHearingStatus: StatusEnum;
    VitalSignStatus: StatusEnum;
}

export class MemberAssessmentStatuses implements IMemberAssessmentStatuses {
    DocumentEngagementId: string;

    AbuseHistoryStatus: StatusEnum;
    AdditionalCHPCriteriaStatus: StatusEnum;
    AdlAssessmentStatus: StatusEnum;
    AdvancedDirectiveStatus: StatusEnum;
    AllergyStatus: StatusEnum;
    BHDiagnosticStatus: StatusEnum;
    BudgetFormStatus: StatusEnum;
    CarePlanStatus: StatusEnum;
    CounselingStatus: StatusEnum;
    CulturalConsiderationsStatus: StatusEnum;
    CurrentNeedsStatus: StatusEnum;
    DiabetesFootStatus: StatusEnum;
    DemographicStatus: StatusEnum;
    DevelopmentalHistoryStatus: StatusEnum;
    DocumentEngagementStatus: StatusEnum;
    EatingDisorderStatus: StatusEnum;
    EducationStatus: StatusEnum;
    FactorAndRiskAssessmentStatus: StatusEnum;
    FallRiskStatus: StatusEnum;
    FollowUpStatus: StatusEnum;
    GAFScaleStatus: StatusEnum;
    GoalStatus: StatusEnum;
    HamiltonAnxietyScaleStatus: StatusEnum;
    HealthPlanStatus: StatusEnum;
    HgbA1CStatus: StatusEnum;
    HraEducationStatus: StatusEnum;
    InterventionStatus: StatusEnum;
    IsConsentToService: boolean;
    LegalHistoryStatus: StatusEnum;
    LipidStatus: StatusEnum;
    MedicationReconciliationStatus: StatusEnum;
    MentalHealthTreatmentHistoryStatus: StatusEnum;
    MiniMentalExamStatus: StatusEnum;
    PastPresentHistoryStatus: StatusEnum;
    PastSurgicalHistoryStatus: StatusEnum;
    PcpSpecialistStatus: StatusEnum;
    PhqStatus: StatusEnum;
    PhysicalExamStatus: StatusEnum;
    PreventativeHealthAdviceStatus: StatusEnum;
    ProgressNoteStatus: StatusEnum;
    RequestStatus: StatusEnum;
    RemoteMonitoringStatus: StatusEnum;
    ReviewSystemStatus: StatusEnum;
    ScreeningFuhfumStatus: StatusEnum;
    SdohAssessmentStatus: StatusEnum;
    SexualHealthStatus: StatusEnum;
    SubjectiveAssessmentStatus: StatusEnum;
    SuicidalHomicidalIdeationStatus: StatusEnum;
    TabletStatus: StatusEnum;
    TobaccoAndDrugAssessmentStatus: StatusEnum;
    UrinalysisReportStatus: StatusEnum;
    VisionAndHearingStatus: StatusEnum;
    VitalSignStatus: StatusEnum;

    constructor() {
        this.DocumentEngagementId = '';
    }
}
